



const styles = {

  errorText: {
    color: 'rgba(255,0,0,0.75)',
    margin: 5,
  },

  orLoginWithEmail: {
    display: 'block',
    textAlign: 'center',
    marginTop: 30,
    color: 'rgba(0,0,0,0.5)',
  },

  alternateOptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },

  loadingContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },

};

export default styles;



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordDialog/styles.js